module.exports = {"id":"s6-q1","text":"Do you have access to a desktop, laptop or tablet computer with internet access?","multiselect":false,"options":[{"id":"s6-q1-a1","text":"Yes","next":"s6-q1a","capability":2,"access":3,"focusarea":[0,0,0,0,4]},{"id":"s6-q1-a2","text":"No","next":"s6-q2","capability":-4,"access":-2}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s6-q1.json
// module id = 913
// module chunks = 41